export default function stopPropagation(event: MouseEvent) {
  return event.stopPropagation()
}
